import { useQuery } from 'react-query';
import {HTTPError} from 'ky';

import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';

export const SMART_REPLIES_PATH = 'api/landlord/messages/smart-replies';

export const getSmartRepliesQueryKey = (leadUuid: string) => [queryKeys.smartReplies, leadUuid];

type ApiResponse = {
    smart_replies: {
        id: number;
        replies: string[];
    };
}

export const useSmartReplies = (
    leadUuid: string,
    onError?: (error: unknown) => void,
    enabled = true
) => {
    const queryKey = getSmartRepliesQueryKey(leadUuid);

    return useQuery(
        queryKey,
        async () => {
            const response = await apiClient(SMART_REPLIES_PATH, {
                searchParams: {
                    lead_uuid: leadUuid
                }
            }).json<ApiResponse>();
            return response.smart_replies;
        },
        {
            enabled,
            onError,
            // do not refetch if 500 & retry up to 3 times otherwise
            retry(count, error: unknown) {
                // in case re return 400 on any error, just stop fetching if it's 400 initially
                if ((error as any)?.response?.status === 400) {
                    return false;
                }
                if (error instanceof HTTPError && error?.response?.status === 500) {
                    return false;
                }
                return count < 3;
            },
        },
    );
};
